<div class="panel-box">
  <div class="pb-header" [translate]="'profile.changePassword.header'">Change password</div>

  <div class="pb-content">
    <form [formGroup]="resetPasswordForm" novalidate>
      <div class="form-group form-group-xl">
        <label [translate]="'profile.changePassword.oldPassword'">Old password</label>

        <input type="password" class="form-control"
               [formControlName]="'oldPassword'"
               [maxlength]="'128'"
               [placeholder]="'profile.changePassword.oldPassword' | translate">
      </div>
      <div class="form-group form-group-xl">
        <label [translate]="'profile.changePassword.newPassword'">New password</label>

        <input type="password" class="form-control"
               [formControlName]="'newPassword'"
               [maxlength]="'128'"
               [placeholder]="'profile.changePassword.newPassword' | translate"
               [class.password-mismatch]="resetPasswordForm['errors']?.mismatched">
      </div>
      <div class="form-group form-group-xl">
        <label [translate]="'profile.changePassword.repeatPassword'">Repeat password</label>

        <input type="password" class="form-control"
               [formControlName]="'confirmPassword'"
               [class.password-mismatch]="resetPasswordForm['errors']?.mismatched"
               [maxlength]="'128'"
               [placeholder]="'profile.changePassword.repeatPassword' | translate">
      </div>

      <ui-message class="d-block mt-3 mb-3" *ngIf="updatePasswordError" [type]="'error'">{{updatePasswordError}}
      </ui-message>

      <div class="text-end">
        <button class="btn btn-primary pe-4 ps-4" (click)="changePassword()"
                [disabled]="!resetPasswordForm.valid" [translate]="'common.change'">
          Change
        </button>
      </div>
    </form>
  </div>

</div>
